"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLocaleLong = exports.isLocaleLong = exports.LocaleLongStruct = void 0;
const superstruct_1 = require("superstruct");
exports.LocaleLongStruct = (0, superstruct_1.enums)([
    'en-GB',
    'de-DE',
    'lt-LT',
    'fr-FR',
    'pt-BR',
    'es-ES',
    'uk-UA',
    'ru-RU',
    'tr-TR',
    'ar-SA',
]);
function isLocaleLong(value) {
    return exports.LocaleLongStruct.is(value);
}
exports.isLocaleLong = isLocaleLong;
exports.DefaultLocaleLong = 'en-GB';
//# sourceMappingURL=locale.js.map